import { AttestationOccupations } from '../components/AttestationSection/AttestationSection.content';
import { SelectableOptionItem } from '@betty/navigation';

export const getOccupationsSelectableOptions = (): SelectableOptionItem[] => {
  return AttestationOccupations.map((str) => ({
    text: str,
  }));
};
